import { store } from "../store";
import Controller from "./Controller";
import apiClientToken from "../plugins/axiosToken";
export default class EquiposComputo {

  getEquiposComputo(context, subnet, conDatosOCS) {
    var t = context;
    var controller = new Controller();
    return new Promise(function (resolve, reject) {
      apiClientToken
        .get(
          store.getters.getUrlServicios +
          "WCFEquiposComputo.svc/RestService/GetEquiposComputo/" +
          subnet + ".0" + "?conDatosOCS=" + conDatosOCS
        )
        .then(function (response) {
          resolve(controller.getData(context, response));
        })
        .catch(function (error) {
          t.$toast.add({
            severity: "error",
            summary: "ERROR",
            detail: "Error al obtener datos del servidor",
            life: 3000,
          });
          console.log(error);
          reject(error);
        });
    });
  }

  
  // Nuevo método para obtener evidencias por lista de verificación
  getEvidenciasByListaVerificacion(context, id) {
    var t = context;
    var controller = new Controller();
    return new Promise(function (resolve, reject) {
      apiClientToken
        .get(
          store.getters.getUrlServicios +
            "WCFEquipos_lista_verificacion.svc/RestService/getEvidenciasByListaVerificacion?id=" +
            id
        )
        .then(function (response) {
          resolve(controller.getData(context, response));
        })
        .catch(function (error) {
          t.$toast.add({
            severity: "error",
            summary: "ERROR",
            detail: "Error al obtener evidencias del servidor",
            life: 3000,
          });
          console.log(error);
          reject(error);
        });
    });
  }

  addEquipoComputo(context, param) {
    var t = context;
    var controller = new Controller();
    return new Promise(function (resolve, reject) {
      apiClientToken
        .post(
          store.getters.getUrlServicios +
            "WCFEquiposComputo.svc/RestService/Add",
          param
        )
        .then(function (response) {
            resolve(controller.getData(context, response));
        })
        .catch(function (error) {
          t.$toast.add({
            severity: "error",
            summary: "ERROR",
            detail: "Error al obtener datos del servidor",
            life: 3000,
          });
          console.log(error);
          reject(error);
        });
    });
  }

  updateEquipoComputo(context, param) {
    var t = context;
    var controller = new Controller();
    return new Promise(function (resolve, reject) {
      apiClientToken
        .post(
          store.getters.getUrlServicios +
            "WCFEquiposComputo.svc/RestService/Update",
          param
        )
        .then(function (response) {
          resolve(controller.getData(context, response));
        })
        .catch(function (error) {
          t.$toast.add({
            severity: "error",
            summary: "ERROR",
            detail: "Error al obtener datos del servidor",
            life: 3000,
          });
          console.log(error);
          reject(error);
        });
    });
}

  deleteEquipoComputo(context, param, id_usuario) {
    var t = context;
    var controller = new Controller();
    return new Promise(function (resolve, reject) {
      apiClientToken
        .post(
          store.getters.getUrlServicios +
            "WCFEquiposComputo.svc/RestService/Delete/" +
            param +
            "/" +
            id_usuario
        )
        .then(function (response) {
          //console.log(response.data.data);
          resolve(controller.getData(context, response));
        })
        .catch(function (error) {
          t.$toast.add({
            severity: "error",
            summary: "ERROR",
            detail: "Error al obtener datos del servidor",
            life: 3000,
          });
          console.log(error);
          reject(error);
        });
    });
  }

  getEquiposPorUnidad(context, unidad) {
    var t = context;
    var controller = new Controller();
    return new Promise(function (resolve, reject) {
      apiClientToken
        .get(
          store.getters.getUrlServicios +
            "WCFEquiposComputo.svc/RestService/getEquiposPorUnidad/" +
            unidad
        )
        .then(function (response) {
          //console.log(response.data.data);
          resolve(controller.getData(context, response));
        })
        .catch(function (error) {
          t.$toast.add({
            severity: "error",
            summary: "ERROR",
            detail: "Error al obtener datos del servidor",
            life: 3000,
          });
          console.log(error);
          reject(error);
        });
    });
  }

  getEquiposPorUnidadSinSubred(context, unidad) {
    var t = context;
    var controller = new Controller();
    return new Promise(function (resolve, reject) {
      apiClientToken
        .get(
          store.getters.getUrlServicios +
            "WCFEquiposComputo.svc/RestService/GetEquiposComputoSinSubredxUnidad/" +
            unidad
        )
        .then(function (response) {
          //console.log(response.data.data);
          resolve(controller.getData(context, response));
        })
        .catch(function (error) {
          t.$toast.add({
            severity: "error",
            summary: "ERROR",
            detail: "Error al obtener datos del servidor",
            life: 3000,
          });
          console.log(error);
          reject(error);
        });
    });
  }

  addEvidencia(context, param) {
    var t = context;
    return new Promise(function (resolve, reject) {
      apiClientToken
        .post(
          store.getters.getUrlServicios +
            "WCFEquipos_lista_verificacion.svc/RestService/Add",
          param, 
          {
            headers: {
              "Content-Type": "application/json", // Asegúrate de que el tipo de contenido sea JSON
            },
          }
        )
        .then(function (response) {
          const data = response.data; 
          resolve(data);
        })
        .catch(function (error) {
          t.$toast.add({
            severity: "error",
            summary: "ERROR",
            detail: "Error al obtener datos del servidor",
            life: 3000,
          });
          console.log(error);
          reject(error);
        });
    });
  }

  getEquipoVerificacion(context, id) {
    var t = context;
    var controller = new Controller();
    return new Promise(function (resolve, reject) {
      apiClientToken
        .get(
          store.getters.getUrlServicios +
            "WCFEquipos_lista_verificacion.svc/RestService/getVerificacion?id=" +
            id
        )
        .then(function (response) {
          resolve(controller.getData(context, response));
        })
        .catch(function (error) {
          t.$toast.add({
            severity: "error",
            summary: "ERROR",
            detail: "Error al obtener datos del servidor",
            life: 3000,
          });
          console.log(error);
          reject(error);
        });
    });
  }

  getEmpleado(context, matricula) {
    var t = context;
    var controller = new Controller();
    return new Promise(function (resolve, reject) {
      apiClientToken
        .get(
          store.getters.getUrlServicios +
            "WCFEmpleados.svc/RestService/getEmpleado?matricula=" +
            matricula
        )
        .then(function (response) {
          resolve(controller.getData(context, response));
        })
        .catch(function (error) {
          t.$toast.add({
            severity: "error",
            summary: "ERROR",
            detail: "Error al obtener datos del servidor",
            life: 3000,
          });
          console.log(error);
          reject(error);
        });
    });
  }

  getEquipoComputo(context,ID) {
    var t = context;
    var controller = new Controller();
    return new Promise(function (resolve, reject) {
      apiClientToken
        .get(
          store.getters.getUrlServicios + "WCFEquiposComputo.svc/RestService/Get/"+ID)
        .then(function (response) {
          resolve(controller.getData(context, response));
        })
        .catch(function (error) {
          t.$toast.add({
            severity: "error",
            summary: "ERROR",
            detail: "Error al obtener datos del servidor",
            life: 3000,
          });
          console.log(error);
          reject(error);
        });
    });
  }


}